import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderActionProps } from '../../../../types/headerActionProps'
import { ActionContent } from '../ActionContent'

export const DuoAction = (props: HeaderActionProps) => {
  const { isDuoSelected, onClickDuo } = usePlansContext()

  return (
    <ActionContent isSelected={isDuoSelected} onClick={onClickDuo} {...props} />
  )
}
